import { n as k, t as I, i as U, a as V, b as C, c as J, d as K, u as Z, e as ee, o as te, f as ne, g as oe } from "./index-Bi-tRlV3.js";
import se, { watch as H, computed as O, ref as h, watchEffect as le, reactive as N, readonly as D, getCurrentInstance as ie, onMounted as re } from "vue";
se.util.warn;
const P = oe ? window : void 0;
function M(n) {
  var t;
  const s = I(n);
  return (t = s == null ? void 0 : s.$el) != null ? t : s;
}
function R(...n) {
  let t, s, c, r;
  if (typeof n[0] == "string" || Array.isArray(n[0]) ? ([s, c, r] = n, t = P) : [t, s, c, r] = n, !t)
    return k;
  Array.isArray(s) || (s = [s]), Array.isArray(c) || (c = [c]);
  const l = [], u = () => {
    l.forEach((f) => f()), l.length = 0;
  }, a = (f, o, i, v) => (f.addEventListener(o, i, v), () => f.removeEventListener(o, i, v)), p = H(
    () => [M(t), I(r)],
    ([f, o]) => {
      if (u(), !f)
        return;
      const i = U(o) ? { ...o } : o;
      l.push(
        ...s.flatMap((v) => c.map((g) => a(f, v, g, i)))
      );
    },
    { immediate: !0, flush: "post" }
  ), d = () => {
    p(), u();
  };
  return V(d), d;
}
function ue() {
  const n = h(!1);
  return ie() && re(() => {
    n.value = !0;
  }, void 0), n;
}
function F(n) {
  const t = ue();
  return O(() => (t.value, !!n()));
}
function ae(n, t, s = {}) {
  const { window: c = P, ...r } = s;
  let l;
  const u = F(() => c && "MutationObserver" in c), a = () => {
    l && (l.disconnect(), l = void 0);
  }, p = O(() => {
    const i = I(n), v = (Array.isArray(i) ? i : [i]).map(M).filter(K);
    return new Set(v);
  }), d = H(
    () => p.value,
    (i) => {
      a(), u.value && i.size && (l = new MutationObserver(t), i.forEach((v) => l.observe(v, r)));
    },
    { immediate: !0, flush: "post" }
  ), f = () => l == null ? void 0 : l.takeRecords(), o = () => {
    d(), a();
  };
  return V(o), {
    isSupported: u,
    stop: o,
    takeRecords: f
  };
}
function ce(n, t = {}) {
  const { window: s = P } = t, c = F(() => s && "matchMedia" in s && typeof s.matchMedia == "function");
  let r;
  const l = h(!1), u = (d) => {
    l.value = d.matches;
  }, a = () => {
    r && ("removeEventListener" in r ? r.removeEventListener("change", u) : r.removeListener(u));
  }, p = le(() => {
    c.value && (a(), r = s.matchMedia(I(n)), "addEventListener" in r ? r.addEventListener("change", u) : r.addListener(u), l.value = r.matches);
  });
  return V(() => {
    p(), a(), r = void 0;
  }), l;
}
function q(n, t, s = {}) {
  const { window: c = P, ...r } = s;
  let l;
  const u = F(() => c && "ResizeObserver" in c), a = () => {
    l && (l.disconnect(), l = void 0);
  }, p = O(() => {
    const o = I(n);
    return Array.isArray(o) ? o.map((i) => M(i)) : [M(o)];
  }), d = H(
    p,
    (o) => {
      if (a(), u.value && c) {
        l = new ResizeObserver(t);
        for (const i of o)
          i && l.observe(i, r);
      }
    },
    { immediate: !0, flush: "post" }
  ), f = () => {
    a(), d();
  };
  return V(f), {
    isSupported: u,
    stop: f
  };
}
function pe(n, t = {}) {
  const {
    reset: s = !0,
    windowResize: c = !0,
    windowScroll: r = !0,
    immediate: l = !0,
    updateTiming: u = "sync"
  } = t, a = h(0), p = h(0), d = h(0), f = h(0), o = h(0), i = h(0), v = h(0), g = h(0);
  function E() {
    const y = M(n);
    if (!y) {
      s && (a.value = 0, p.value = 0, d.value = 0, f.value = 0, o.value = 0, i.value = 0, v.value = 0, g.value = 0);
      return;
    }
    const w = y.getBoundingClientRect();
    a.value = w.height, p.value = w.bottom, d.value = w.left, f.value = w.right, o.value = w.top, i.value = w.width, v.value = w.x, g.value = w.y;
  }
  function S() {
    u === "sync" ? E() : u === "next-frame" && requestAnimationFrame(() => E());
  }
  return q(n, S), H(() => M(n), (y) => !y && S()), ae(n, S, {
    attributeFilter: ["style", "class"]
  }), r && R("scroll", S, { capture: !0, passive: !0 }), c && R("resize", S, { passive: !0 }), C(() => {
    l && S();
  }), {
    height: a,
    bottom: p,
    left: d,
    right: f,
    top: o,
    width: i,
    x: v,
    y: g,
    update: S
  };
}
function he(n, t = { width: 0, height: 0 }, s = {}) {
  const { window: c = P, box: r = "content-box" } = s, l = O(() => {
    var o, i;
    return (i = (o = M(n)) == null ? void 0 : o.namespaceURI) == null ? void 0 : i.includes("svg");
  }), u = h(t.width), a = h(t.height), { stop: p } = q(
    n,
    ([o]) => {
      const i = r === "border-box" ? o.borderBoxSize : r === "content-box" ? o.contentBoxSize : o.devicePixelContentBoxSize;
      if (c && l.value) {
        const v = M(n);
        if (v) {
          const g = v.getBoundingClientRect();
          u.value = g.width, a.value = g.height;
        }
      } else if (i) {
        const v = Array.isArray(i) ? i : [i];
        u.value = v.reduce((g, { inlineSize: E }) => g + E, 0), a.value = v.reduce((g, { blockSize: E }) => g + E, 0);
      } else
        u.value = o.contentRect.width, a.value = o.contentRect.height;
    },
    s
  );
  C(() => {
    const o = M(n);
    o && (u.value = "offsetWidth" in o ? o.offsetWidth : t.width, a.value = "offsetHeight" in o ? o.offsetHeight : t.height);
  });
  const d = H(
    () => M(n),
    (o) => {
      u.value = o ? t.width : 0, a.value = o ? t.height : 0;
    }
  );
  function f() {
    p(), d();
  }
  return {
    width: u,
    height: a,
    stop: f
  };
}
const $ = 1;
function me(n, t = {}) {
  const {
    throttle: s = 0,
    idle: c = 200,
    onStop: r = k,
    onScroll: l = k,
    offset: u = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    },
    eventListenerOptions: a = {
      capture: !1,
      passive: !0
    },
    behavior: p = "auto",
    window: d = P,
    onError: f = (e) => {
      console.error(e);
    }
  } = t, o = h(0), i = h(0), v = O({
    get() {
      return o.value;
    },
    set(e) {
      E(e, void 0);
    }
  }), g = O({
    get() {
      return i.value;
    },
    set(e) {
      E(void 0, e);
    }
  });
  function E(e, b) {
    var m, x, A, T;
    if (!d)
      return;
    const _ = I(n);
    if (!_)
      return;
    (A = _ instanceof Document ? d.document.body : _) == null || A.scrollTo({
      top: (m = I(b)) != null ? m : g.value,
      left: (x = I(e)) != null ? x : v.value,
      behavior: I(p)
    });
    const L = ((T = _ == null ? void 0 : _.document) == null ? void 0 : T.documentElement) || (_ == null ? void 0 : _.documentElement) || _;
    v != null && (o.value = L.scrollLeft), g != null && (i.value = L.scrollTop);
  }
  const S = h(!1), y = N({
    left: !0,
    right: !1,
    top: !0,
    bottom: !1
  }), w = N({
    left: !1,
    right: !1,
    top: !1,
    bottom: !1
  }), B = (e) => {
    S.value && (S.value = !1, w.left = !1, w.right = !1, w.top = !1, w.bottom = !1, r(e));
  }, Y = Z(B, s + c), z = (e) => {
    var b;
    if (!d)
      return;
    const m = ((b = e == null ? void 0 : e.document) == null ? void 0 : b.documentElement) || (e == null ? void 0 : e.documentElement) || M(e), { display: x, flexDirection: A } = getComputedStyle(m), T = m.scrollLeft;
    w.left = T < o.value, w.right = T > o.value;
    const _ = Math.abs(T) <= (u.left || 0), L = Math.abs(T) + m.clientWidth >= m.scrollWidth - (u.right || 0) - $;
    x === "flex" && A === "row-reverse" ? (y.left = L, y.right = _) : (y.left = _, y.right = L), o.value = T;
    let W = m.scrollTop;
    e === d.document && !W && (W = d.document.body.scrollTop), w.top = W < i.value, w.bottom = W > i.value;
    const j = Math.abs(W) <= (u.top || 0), Q = Math.abs(W) + m.clientHeight >= m.scrollHeight - (u.bottom || 0) - $;
    x === "flex" && A === "column-reverse" ? (y.top = Q, y.bottom = j) : (y.top = j, y.bottom = Q), i.value = W;
  }, X = (e) => {
    var b;
    if (!d)
      return;
    const m = (b = e.target.documentElement) != null ? b : e.target;
    z(m), S.value = !0, Y(e), l(e);
  };
  return R(
    n,
    "scroll",
    s ? ee(X, s, !0, !1) : X,
    a
  ), C(() => {
    try {
      const e = I(n);
      if (!e)
        return;
      z(e);
    } catch (e) {
      f(e);
    }
  }), R(
    n,
    "scrollend",
    B,
    a
  ), {
    x: v,
    y: g,
    isScrolling: S,
    arrivedState: y,
    directions: w,
    measure() {
      const e = I(n);
      d && e && z(e);
    }
  };
}
const G = {
  x: 0,
  y: 0,
  pointerId: 0,
  pressure: 0,
  tiltX: 0,
  tiltY: 0,
  width: 0,
  height: 0,
  twist: 0,
  pointerType: null
}, de = /* @__PURE__ */ Object.keys(G);
function we(n = {}) {
  const {
    target: t = P
  } = n, s = h(!1), c = h(n.initialValue || {});
  Object.assign(c.value, G, c.value);
  const r = (l) => {
    s.value = !0, !(n.pointerTypes && !n.pointerTypes.includes(l.pointerType)) && (c.value = te(l, de, !1));
  };
  if (t) {
    const l = { passive: !0 };
    R(t, ["pointerdown", "pointermove", "pointerup"], r, l), R(t, "pointerleave", () => s.value = !1, l);
  }
  return {
    ...J(c),
    isInside: s
  };
}
function be(n, t = {}) {
  const s = ne(n), {
    threshold: c = 50,
    onSwipe: r,
    onSwipeEnd: l,
    onSwipeStart: u,
    disableTextSelect: a = !1
  } = t, p = N({ x: 0, y: 0 }), d = (e, b) => {
    p.x = e, p.y = b;
  }, f = N({ x: 0, y: 0 }), o = (e, b) => {
    f.x = e, f.y = b;
  }, i = O(() => p.x - f.x), v = O(() => p.y - f.y), { max: g, abs: E } = Math, S = O(() => g(E(i.value), E(v.value)) >= c), y = h(!1), w = h(!1), B = O(() => S.value ? E(i.value) > E(v.value) ? i.value > 0 ? "left" : "right" : v.value > 0 ? "up" : "down" : "none"), Y = (e) => {
    var b, m, x;
    const A = e.buttons === 0, T = e.buttons === 1;
    return (x = (m = (b = t.pointerTypes) == null ? void 0 : b.includes(e.pointerType)) != null ? m : A || T) != null ? x : !0;
  }, z = [
    R(n, "pointerdown", (e) => {
      if (!Y(e))
        return;
      w.value = !0;
      const b = e.target;
      b == null || b.setPointerCapture(e.pointerId);
      const { clientX: m, clientY: x } = e;
      d(m, x), o(m, x), u == null || u(e);
    }),
    R(n, "pointermove", (e) => {
      if (!Y(e) || !w.value)
        return;
      const { clientX: b, clientY: m } = e;
      o(b, m), !y.value && S.value && (y.value = !0), y.value && (r == null || r(e));
    }),
    R(n, "pointerup", (e) => {
      Y(e) && (y.value && (l == null || l(e, B.value)), w.value = !1, y.value = !1);
    })
  ];
  C(() => {
    var e, b, m, x, A, T, _, L;
    (b = (e = s.value) == null ? void 0 : e.style) == null || b.setProperty("touch-action", "none"), a && ((x = (m = s.value) == null ? void 0 : m.style) == null || x.setProperty("-webkit-user-select", "none"), (T = (A = s.value) == null ? void 0 : A.style) == null || T.setProperty("-ms-user-select", "none"), (L = (_ = s.value) == null ? void 0 : _.style) == null || L.setProperty("user-select", "none"));
  });
  const X = () => z.forEach((e) => e());
  return {
    isSwiping: D(y),
    direction: D(B),
    posStart: D(p),
    posEnd: D(f),
    distanceX: i,
    distanceY: v,
    stop: X
  };
}
function ye(n = {}) {
  const { window: t = P, behavior: s = "auto" } = n;
  if (!t)
    return {
      x: h(0),
      y: h(0)
    };
  const c = h(t.scrollX), r = h(t.scrollY), l = O({
    get() {
      return c.value;
    },
    set(a) {
      scrollTo({ left: a, behavior: s });
    }
  }), u = O({
    get() {
      return r.value;
    },
    set(a) {
      scrollTo({ top: a, behavior: s });
    }
  });
  return R(
    t,
    "scroll",
    () => {
      c.value = t.scrollX, r.value = t.scrollY;
    },
    {
      capture: !1,
      passive: !0
    }
  ), { x: l, y: u };
}
function ge(n = {}) {
  const {
    window: t = P,
    initialWidth: s = Number.POSITIVE_INFINITY,
    initialHeight: c = Number.POSITIVE_INFINITY,
    listenOrientation: r = !0,
    includeScrollbar: l = !0,
    type: u = "inner"
  } = n, a = h(s), p = h(c), d = () => {
    t && (u === "outer" ? (a.value = t.outerWidth, p.value = t.outerHeight) : l ? (a.value = t.innerWidth, p.value = t.innerHeight) : (a.value = t.document.documentElement.clientWidth, p.value = t.document.documentElement.clientHeight));
  };
  if (d(), C(d), R("resize", d, { passive: !0 }), r) {
    const f = ce("(orientation: portrait)");
    H(f, () => d());
  }
  return { width: a, height: p };
}
export {
  q as a,
  ge as b,
  ye as c,
  he as d,
  me as e,
  ae as f,
  be as g,
  we as h,
  R as i,
  pe as u
};
